/**
 * Vuex mutations for the "securityAuth" (twoFactorAuth) module.
 *
 * Synchronous state writers for 2FA status, setup data (QR code/secret),
 * loading flag, and status message. Async work (API calls) lives in
 * operations.js, which commits these mutations with the results.
 */
export default {
  setLoading(state, payload) {
    state.isLoading = payload;
  },
  setTwoFaStatus(state, payload) {
    state.isTwoFaEnabled = payload;
  },
  setQrCode(state, payload) {
    state.qrCodeDataUrl = payload;
  },
  setSecretKey(state, payload) {
    state.secretKey = payload;
  },
  setMessage(state, payload) {
    state.message = payload;
  },
  /** Clear the generated QR code and secret key (e.g. after 2FA is successfully enabled). */
  resetQrData(state) {
    state.qrCodeDataUrl = "";
    state.secretKey = "";
  },
};
